/**
 * An object event resolution.
 *
 * @property {string} userId - User ID of the user which resolved the event.
 * @property {string} time   - Time of event resolving.
 */
export class ObjectEventResolution {
    /**
     * Creates a new ObjectEventResolution object with all required properties.
     *
     * @param {string} userId - User ID of the user which resolved the event.
     * @param {string} time   - Time of event resolving.
     */
    constructor(userId, time) {
        this.userId = userId
        this.time = time
    }
}
